import { Component, AfterViewInit } from '@angular/core';

import { SystemMessageService } from '../../system-message/system-message-service';
import { validateForm } from '../../../shared/form-elements/form-validateForm.function';
import { ForgotPasswordVm } from '../../../shared/generated/Models/ForgotPasswordVm';

@Component({
    selector: 'pcg-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements AfterViewInit {

	forgotPasswordForm = ForgotPasswordVm.Form;
	checkEmail = false;

	constructor(private ms: SystemMessageService) { }

    ngAfterViewInit() { }

	onSubmit() {
		if (this.forgotPasswordForm.valid) {
			this.ms.getHttpObservable(this, 'api/Account/ForgotPassword', this.forgotPasswordForm)
				.subscribe(msg => {
					if (
                        msg 
                        && msg.isSuccessful
                    ) { this.checkEmail = true; }
				}
			);
		} else { validateForm(this.forgotPasswordForm); }
	}
}
